





















import Vue from 'vue'

export interface RangeValue {
  start: Date
  end: Date
}

interface Props {
  filterValue: string
}
interface Data {
  inputValues: RangeValue
}

interface Methods {
  changeInput: () => void
  setValues: () => void
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    filterValue: {
      required: true,
    },
  },
  data() {
    return {
      inputValues: {
        start: new Date(Date.now() - 86400000),
        end: new Date(),
      },
    }
  },
  methods: {
    changeInput() {
      const newFilterValue =
        Date.parse(this.inputValues.start.toString()) / 1000 +
        '-' +
        Date.parse(this.inputValues.end.toString()) / 1000
      this.$emit('input', newFilterValue)
    },
    setValues() {
      if (
        this.filterValue &&
        this.filterValue.toString().split('-').length === 2
      ) {
        this.inputValues = {
          start: new Date(Number(this.filterValue.split('-')[0]) * 1000),
          end: new Date(Number(this.filterValue.split('-')[1]) * 1000),
        }
      }
      this.changeInput()
    },
  },
  mounted() {
    this.setValues()
  },
  watch: {
    '$route.query.filter'() {
      this.setValues()
    },
  },
})
